import React, { useEffect, useState } from "react";
import "./GroupLoansViewLateFees.scss";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import CloseIcon from "@mui/icons-material/Close";
import GroupLoansTable from "../../../components/GroupLoansTable/GroupLoansTable";
import GroupLoansLateFeePayments from "../GroupLoansLateFeePayments/GroupLoansLateFeePayments";
import BaseDrawer from "../../../components/UI/BaseDrawer/BaseDrawer";

const GroupLoansViewLateFees = ({ selectedLoan, setLoansListView, selectedMemberName }) => {
    const [lateFeesListView, setLateFeesListView] = useState(null);
    const [lateFeesArray, setLateFeesArray] = useState([]);
    const [loading, setLoading] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [selectedLateFee, setSelectedLateFee] = useState(null);
    const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);

    useEffect(()=> {
        console.log("selectedLoannnnn------------",selectedLoan)
        getLoanLateFees();
    },[selectedLoan]);

    const getLoanLateFees = async() => {
        try {
            const response = await commonRunQuery(234, `${selectedLoan?.li?.loanid}`);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const loansArr = Array.isArray(response?.data?.body?.record)
                        ? response?.data?.body?.record
                        : [response?.data?.body?.record];
      
                setLateFeesArray(loansArr);
              console.log("getLoanLateFees_response==========",loansArr);
            } else {
                console.log("getLoanLateFees_response==========",response);
                setLateFeesArray([]);
            }
        } catch (error) {
            console.log("getLoanLateFees_error==========",error);
        } finally {
            setLoading(false)
        }
    }

    const columns = [
        {
            label: 'Late Fee Id',
            getValue: (row) => row?.loanlatefees?.latefeeid ?? ''
        },
        {
            label: 'Loan Id',
            getValue: (row) => row?.loanlatefees?.loanid ?? ''
        },
        {
            label: 'Late Fee',
            getValue: (row) => row?.loanlatefees?.latefee  ?? '',
            align: 'right',
            amount: true
        },
        {
            label: 'Outstanding Fee',
            getValue: (row) => row?.loanlatefees?.outstandingfee ?? '',
            align: 'right',
            amount: true
        },
        {
            label: 'Date',
            getValue: (row) => row?.loanlatefees?.transdate ?? ''
        },
        {
            label: 'Fully Paid',
            getValue: (row) => row?.loanlatefees?.fullypaid == "1" ? "Yes" : "No"
        }
        
    ];

    const handleMenuOpen = (event, loan) => {
        console.log("handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedLateFee(loan);
    };

    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
    };

    return (
        <Box>
            {
                lateFeesListView == null && <Box className="d-flex justify-content-between">
                    <Typography
                        sx={{
                            fontFamily: "'Nunito'",
                            fontStyle: "normal",
                            fontWeight: 500,
                            fontSize: "21.4825px",
                            color: "#3A3A3A",
                        }}
                        className=""
                    >
                        View Late Fees - {selectedMemberName}
                    </Typography>

                    <Button
                        className="fs-size-12 paiy-blue text-white"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setLoansListView(null);
                        }}
                    >
                        Return
                    </Button>
                </Box>
            }

            {
                lateFeesListView == null && <Box className="mt-4">
                    <GroupLoansTable
                        data={lateFeesArray} 
                        columns={columns} 
                        title="Late Fees" 
                        formatRow={(row) => [
                            row.id,
                            row.record?.BorrowerName,
                            row.name,
                            row.balance,
                            row.record?.DaysPastDue,
                            row.record?.AmountDue
                        ]} 
                        viewMenu={true}
                        handleMenuOpen={handleMenuOpen}
                        downloads={false}
                        // author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
                    />
                </Box>
            }

            { lateFeesListView == "viewPayments" && <GroupLoansLateFeePayments selectedLateFee={selectedLateFee} setLateFeesListView={setLateFeesListView} selectedMemberName={selectedMemberName} /> }
            
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem
                    onClick={() => {
                        setLateFeesListView('viewPayments');
                        handleMenuClose();
                    }}
                >
                    View Payments
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        // setOpenDetailsDialog(true);
                        setOpenDetailsDrawer(true);
                        handleMenuClose();
                    }}
                >
                    View Details
                </MenuItem>
            </Menu>

            <BaseDrawer
                open={openDetailsDrawer}
                handleClose={() => setOpenDetailsDrawer(false)}
                height="70vh"
                className="loanProductInfoDrawer"
                overflow="auto"
            >
                {selectedLateFee && (
                    <Box>
                        <Box className="user-accounts-tab">
                            <Box className="balance-container">
                                <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                    {/* Left Column */}
                                    <Box minWidth="300px" flex={1}>
                                        {[
                                        { label: "Late Fee ID", value: selectedLateFee?.loanlatefees?.latefeeid },
                                        { label: "User ID", value: selectedLateFee?.loanlatefees?.userid },
                                        { label: "Loan ID", value: selectedLateFee?.loanlatefees?.loanid },
                                        { label: "Currency Code", value: selectedLateFee?.loanlatefees?.currcode || "N/A" },
                                        { label: "Transaction Date", value: selectedLateFee?.loanlatefees?.transdate || "N/A" },
                                        { label: "Last Update Date", value: selectedLateFee?.loanlatefees?.lastupdatedate || "N/A" },
                                        { label: "Fully Paid", value: selectedLateFee?.loanlatefees?.fullypaid === "1" ? "Yes" : "No" },
                                        { label: "Reason Code", value: selectedLateFee?.loanlatefees?.reason || "N/A" },
                                        ].map(({ label, value }, index) => (
                                        <Box className="info-container" key={index}>
                                            <Box className="info-type">{label}:</Box>
                                            <Box className="info-response">{value || "N/A"}</Box>
                                        </Box>
                                        ))}
                                    </Box>

                                    {/* Right Column */}
                                    <Box minWidth="300px" flex={1}>
                                        {[
                                        { label: "Outstanding Amount", value: selectedLateFee?.loanlatefees?.outstandingamount },
                                        { label: "Late Fee", value: selectedLateFee?.loanlatefees?.latefee },
                                        { label: "Paid Amount", value: selectedLateFee?.loanlatefees?.paidamount },
                                        { label: "Outstanding Fee", value: selectedLateFee?.loanlatefees?.outstandingfee },
                                        ].map(({ label, value }, index) => (
                                        <Box className="info-container" key={index}>
                                            <Box className="info-type">{label}:</Box>
                                            <Box className="info-response">
                                            {value ? Number(value).toLocaleString() : "N/A"}
                                            </Box>
                                        </Box>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                )}
            </BaseDrawer>

            {/* <Dialog
                open={openDetailsDialog}
                onClose={() => setOpenDetailsDialog(false)}
                fullWidth
                maxWidth="sm"
                className="loans-dialog"
            >
                <DialogTitle>
                    <Box>
                        Loan Details
                        <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                            <IconButton onClick={() => setOpenDetailsDialog(false)} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedLateFee && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                    <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                        <Box minWidth="300px" flex={1}>
                                            {[
                                            { label: "Late Fee ID", value: selectedLateFee?.loanlatefees?.latefeeid },
                                            { label: "User ID", value: selectedLateFee?.loanlatefees?.userid },
                                            { label: "Loan ID", value: selectedLateFee?.loanlatefees?.loanid },
                                            { label: "Currency Code", value: selectedLateFee?.loanlatefees?.currcode || "N/A" },
                                            { label: "Transaction Date", value: selectedLateFee?.loanlatefees?.transdate || "N/A" },
                                            { label: "Last Update Date", value: selectedLateFee?.loanlatefees?.lastupdatedate || "N/A" },
                                            { label: "Fully Paid", value: selectedLateFee?.loanlatefees?.fullypaid === "1" ? "Yes" : "No" },
                                            { label: "Reason Code", value: selectedLateFee?.loanlatefees?.reason || "N/A" },
                                            ].map(({ label, value }, index) => (
                                            <Box className="info-container" key={index}>
                                                <Box className="info-type">{label}:</Box>
                                                <Box className="info-response">{value || "N/A"}</Box>
                                            </Box>
                                            ))}
                                        </Box>

                                        <Box minWidth="300px" flex={1}>
                                            {[
                                            { label: "Outstanding Amount", value: selectedLateFee?.loanlatefees?.outstandingamount },
                                            { label: "Late Fee", value: selectedLateFee?.loanlatefees?.latefee },
                                            { label: "Paid Amount", value: selectedLateFee?.loanlatefees?.paidamount },
                                            { label: "Outstanding Fee", value: selectedLateFee?.loanlatefees?.outstandingfee },
                                            ].map(({ label, value }, index) => (
                                            <Box className="info-container" key={index}>
                                                <Box className="info-type">{label}:</Box>
                                                <Box className="info-response">
                                                {value ? Number(value).toLocaleString() : "N/A"}
                                                </Box>
                                            </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDetailsDialog(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog> */}
        </Box>
    )
}

export default GroupLoansViewLateFees;
